import React from 'react';
import { useState, useEffect, useRef, useContext } from 'react';
import { ServiceEditor } from './ServiceEditor';
import { SlidingPane } from '../SlidingPane';
import { Button, Card, Modal } from 'react-bootstrap';
import { AlertInstructions } from "./AlertInstructions";
import * as BsIcons from "react-icons/bs";
import { IconName } from "react-icons/gr";
import { AlignCenter, EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { getAPI } from '../GdacsAPI';

const Services = (props) => {
    const params = props.params;
    const paramsAddress = props.params.addresses;
    const [services, setServices] = React.useState(params?.services.map((a, i) => ({ ...a, id: i })) ?? []);
    const [service, setService] = useState();
    const [isEditorVisible, setIsEditorVisible] = useState();
    const [regions, setRegions] = React.useState([]);
    const [servicestypesdevice, setServicesTypesDevice] = React.useState([]);
    const [language, setLanguage] = React.useState([]);
    const [eventtypes, setEventTypes] = React.useState([]);
    const [editingServiceId, setEditingServiceId] = React.useState();
    const [responseMessage, setResponseMessage] = React.useState("");
    const [isVisible, setIsVisible] = React.useState();
    const [isModified, setIsModified] = React.useState(false);
    const [show, setShow] = React.useState(false);

    React.useEffect(() => {
        props.isButtonDisabled(isModified);
    }, []);

    const handleChangeButton = (isButtonDisabled) => {
        props.isButtonDisabled(isButtonDisabled);
    }

    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypesDevice('Failed to retreive services types data.');
            return;
        }
        const servicesTypesData = await response.json();
        if (servicesTypesData) {
            setServicesTypesDevice(servicesTypesData);
            setLanguage(servicesTypesData[1].listLanguages);
        }
    }

    async function GetRegions() {
        var url = getAPI() + `api/register/Definition/regions/`;
        const response = await fetch(url);
        if (!response.ok) {
            setRegions('Failed to retreive regions data.');
            return;
        }
        const regionsData = await response.json();
        if (regionsData) {
            setRegions(regionsData);
        }
    }

    async function GetEventTypes() {
        var url = getAPI() + `api/register/Definition/eventtypes/`;
        const response = await fetch(url);
        if (!response.ok) {
            setEventTypes('Failed to retreive event types data.');
            return;
        }
        const eventtypesData = await response.json();
        if (eventtypesData) {
            setEventTypes(eventtypesData);
        }
    }


    React.useEffect(() => {
        GetServicesTypes();
        GetRegions();
        GetEventTypes();
    }, []);

    const handleInstructions = () => {
        setIsVisible(true);
    }

    const handleSaveService = (service) => {
        const err = checkService(service);
        if (checkService(service) === "") {
            setServices(aa => {
                let newServices = [...aa];
                const serviceIndex = newServices.findIndex(a => a.id === service.id);
                if (serviceIndex === -1) {
                    var id = Math.max.apply(Math, newServices.map(a => a.id));
                    newServices.push({ ...service, id: isFinite(id) ? id + 1 : 0 });
                }
                else
                    newServices[serviceIndex] = service;

                return newServices
            });

            setEditingServiceId(undefined);
            handleChangeButton(false);
            setIsEditorVisible(false);
            setResponseMessage(err);
        }
        else {
            setEditingServiceId(undefined);
            setIsEditorVisible(false);
            setResponseMessage(err);
            setShow(true);
        }


    }

    const checkService = (service) => {
        let array = [...services];
        let message = "";

        if (service.idServiceType === 1) {
            let c = paramsAddress.filter(x => x.idServiceType === 1).length;
            if (c === 0)
                message = "The channel inserted is not available in your list. Please check your list of channels.";
        }
        if (service.idServiceType === 3) {
            let c = paramsAddress.filter(x => x.idServiceType === 3).length;
            if (c === 0)
                message = "The channel inserted is not available in your list. Please check your list of channels.";
        }
        if (service.idServiceType === 10) {
            let c = paramsAddress.filter(x => x.idServiceType === 10).length;
            if (c === 0)
                message = "The channel inserted is not available in your list. Please check your list of channels.";
        }

        for (let i = 0; i < array.length; i++) {
            if (array[i].idServiceType === service.idServiceType && array[i].eventType === service.eventType &&
                array[i].alertLevel === service.alertLevel && array[i].region === service.region && array[i].language === service.language &&
                array[i].stopNight === service.stopNight && array[i].enabled === service.enabled)
                message = "The alert for this hazard has been already inserted. Please check.";
        }

        return message;
    }

    React.useEffect(() => {
        props.onChange(services);
    }, [services]);

    const handleServiceAdd = () => {
        setService(null);
        setIsEditorVisible(true);
    }


    const handleServiceEdit = (e, id) => {
        const aIndex = services.findIndex(x => x.id === id);
        if (aIndex === -1) return;
        setService({ ...services[aIndex] });
        setIsEditorVisible(true);
    }

    const handleCancelRow = () => {
        setIsEditorVisible(false);
    }

    const handleDeleteService = (e) => {
        setServices(aa => aa.filter(a => a.id !== e));
    }

    const handleClose = () => {
        setShow(false);
    }

    return (
        <div>
            <div className="col-12">
                <button type="button" className="btn btn-info" onClick={handleServiceAdd}>Add</button>
                <Button variant="link" className="float-right btn-sm" onClick={handleInstructions}>How to configure your notifications</Button>
            </div>
            <br />
            <div>
                {
                    services.map((item, index) => {
                        return (

                            <div >
                                <Card className="primary">
                                    <Card.Header style={{ color: "white", backgroundColor: "#c6c2c2" }}>
                                        <table style={{ width: "100%" }}>
                                            <tr >
                                                <td style={{ width: "20%" }}>
                                                    {item.eventType === "NL" ?
                                                        <img src={`Images/NL_Blue.png`} style={{ width: "30px", height: "30px" }} /> :
                                                        <img src={`Images/gdacs_icons/alerts/${item.alertLevel}/${item.eventType}.png`} style={{ width: "30px", height: "30px" }} />}
                                                </td>
                                                {
                                                    eventtypes.filter(event => event.eventtype === item.eventType).map(types => (
                                                        <td key={types.eventType} style={{ width: "80%" }}><b>{types.description}</b></td>
                                                    ))}
                                            </tr>
                                        </table>
                                    </Card.Header>
                                    <Card.Body className="card-body flex-column h-100">
                                        <Card.Text>
                                            <table style={{ width: "100%" }}>
                                                <tr>
                                                    <td style={{ width: "50%" }}>Channel : </td>
                                                    {servicestypesdevice.filter(itemServ => itemServ.idServiceType === item.idServiceType).map(types => (
                                                        <td key={types.idServiceType} style={{ width: "50%" }}>
                                                            {types.idServiceType === 1 ?
                                                                <EnvelopeFill color="#0099CC" size={18} />
                                                                : types.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                                                                    : <Phone color="#0099CC" size={18} />
                                                            }
                                                        </td>
                                                    ))}
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "50%" }}>Region : </td>
                                                    {
                                                        regions.filter(itemReg => itemReg.idRegion === item.region).map(reg => (
                                                            <td key={reg.idregion}><b>{reg.regionName}</b></td>
                                                        ))
                                                    }
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "50%" }}>Language : </td>
                                                    {
                                                        language.filter(itemLang => itemLang.key === item.language).map(lang => (
                                                            <td key={lang.language}><b>{lang.value}</b></td>
                                                        ))
                                                    }
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "50%" }}>Quiet Night :</td>
                                                    <td style={{ width: "50%" }}>
                                                        {
                                                            item.stopNight === true ? <BsIcons.BsCheck color="#044257" size={18} /> : <></>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "50%" }}>Enable :</td>
                                                    <td style={{ width: "50%" }}>
                                                        {
                                                            item.enabled === true ? <BsIcons.BsCheck color="#0099CC" size={18} /> : <></>
                                                        }
                                                    </td>
                                                </tr>
                                                <br />
                                                <tr>
                                                    <td >
                                                        <button type="button" value={item.id} className="btn btn-info" onClick={(event) => handleServiceEdit(event, item.id)} >Edit</button>
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        <button type="button" value={item.id} className="btn btn-info" onClick={() => handleDeleteService(item.id)} >Delete</button>
                                                    </td>
                                                </tr>
                                            </table>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                                <br />
                            </div>
                        )
                    }

                    )
                }
            </div>
            <Modal className="d-flex justify-content-left" show={show} onHide={handleClose} >
                <Modal.Header closeButton>
                    <Modal.Title>User Account</Modal.Title>
                </Modal.Header>
                <><Modal.Body>{responseMessage}</Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => handleClose()}>
                            OK
                    </Button>
                    </Modal.Footer></>
            </Modal>
            <SlidingPane from="right" style={{ width: "90%" }} isOpen={isEditorVisible} onRequestClose={() => { setIsEditorVisible(false); setService(null); setIsVisible(false); }}>
                <ServiceEditor service={service} onRequestSaveService={handleSaveService} onRequestCancel={handleCancelRow} >

                </ServiceEditor>
            </SlidingPane>
            <SlidingPane from="right" style={{ width: "90%" }} isOpen={isVisible} onRequestClose={() => { setIsVisible(false) }}>
                <AlertInstructions />
            </SlidingPane>
        </div>
    );

}
export { Services }